import moment from 'moment'

// shared decimal normaliser
export const dec = v => {
	if (v == null) return 0
	if (typeof v === 'object' && v.$numberDecimal !== undefined) {
		const n = Number(v.$numberDecimal)
		return Number.isFinite(n) ? n : 0
	}
	const n = Number(v)
	return Number.isFinite(n) ? n : 0
}

// Returns YYYY-MM-DD (safe for <input type="date">)
export const toYMD = d => {
	if (!d) return ''
	const m = moment(d)
	if (!m.isValid()) return ''
	return m.format('YYYY-MM-DD')
}

// Derive status without duplicating in component
export const deriveStatus = inv => {
	if (!inv) return 'issued'
	if (inv.status) return inv.status
	if (inv.paidDate) return 'paid'
	if (inv.paymentTerm && moment().isAfter(moment(inv.paymentTerm))) return 'overdue'
	return 'issued'
}

// Build partial form state from loaded invoice
export const buildFormFromInvoice = data => {
	const products = Array.isArray(data.products) && data.products.length
		? data.products.map(p => ({
				name: p.name || '',
				sku: p.sku || p.productId?.sku || '',
				article_number: p.article_number || p.productId?.article_number || '',
				price: String(dec(p.price) || 0),
				count: String(Number.isFinite(p.count) ? p.count : 1),
				subtotal: dec(p.subtotal || 0),
				taxValue: dec(p.taxValue || 0),
				total: dec(p.total || 0),
				taxPercent: String(dec(p.taxPercent) || 0),
				productId: (p.productId?._id || p.productId || '').toString(),
			}))
		: undefined

	return {
		customerId: (data.customerId?._id || data.customerId || '').toString(),
		customerName: data.customerName || data.customerId?.name || '',
		invoiceNumber: data.number || '',
		invoiceDate: toYMD(data.invoiceDate || data.date),
		// discountPercent is the authoritative field used by useInvoiceFormState
		// fallback to legacy discount field if present
		discountPercent: String(dec(data.discountPercent ?? data.discount) || 0),
		publicNotes: data.publicNotes || '',
		privateNotes: data.privateNotes || '',
		paymentType: data.paymentType || 'card',
		paymentDate: toYMD(data.paidDate),
		products: products || undefined,
		// Some older records use paymentTerm instead of dueDate
		dueDate: toYMD(data.dueDate || data.paymentTerm),
		status: deriveStatus(data),
        subtotal: dec(data.subtotal || 0),
        taxTotal: dec(data.taxTotal || 0),
        total: dec(data.total || 0),
        discountValue: dec(data.discountValue || 0),
	}
}
